var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.467 3.497H6.26L4.885 2.182a.096.096 0 0 0-.064-.026H1.84a.375.375 0 0 0-.374.375V9.47c0 .207.167.375.375.375h8.625a.375.375 0 0 0 .375-.375V3.872a.375.375 0 0 0-.375-.375z",
    fill: "#007CF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsicon);
export default __webpack_public_path__ + "static/media/documents icon .56c3e60fab5436ca6c68b26e8b703bdd.svg";
export { ForwardRef as ReactComponent };